const canCopyToClipboard: boolean = !!document.queryCommandSupported && document.queryCommandSupported('copy')

function copyToClipboard(textToCopy: string): boolean | void {
  // 1. Create a text area
  const textArea = document.createElement('textarea')
  textArea.id = 'ww-copy-textarea'
  textArea.value = textToCopy
  textArea.style.cssText = `
    position: absolute;
    top: -1000px;
    left: -1000px;
  `
  document.body.appendChild(textArea)
  textArea.select()
  const copyResult = document.execCommand('copy')
  // clean up
  document.body.removeChild(textArea)
  return copyResult
}

export { canCopyToClipboard, copyToClipboard }
